import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0392780d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OkSwitch__container" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["OkSwitch", { 'OkSwitch--disabled': _ctx.disabled }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["container__option", { 'option--active': _ctx.isOptionSelected(option) }]),
          key: `option-${i}`,
          onClick: ($event: any) => (_ctx.selectOption(option))
        }, _toDisplayString(option.name), 11, _hoisted_2))
      }), 128))
    ])
  ], 2))
}